import React, { useState } from 'react';
import clsx from 'clsx';
import AntSwitch, { SwitchSize } from 'antd/lib/switch';
import styles from './Switch.module.less';

type PropsSwitch = {
  shouldUseState?: boolean;
  notClickable?: boolean;
  size?: SwitchSize;
  checked?: boolean;
  style?: React.CSSProperties;
  className?: string;
  onChange?: () => void;
};

export const Switch: React.FC<PropsSwitch> = ({
  size = 'small',
  checked: propChecked,
  style,
  className,
  notClickable = false,
  shouldUseState = true,
  onChange = () => {},
}) => {
  const [checked, setChecked] = useState(propChecked ?? false);

  const handleChange = () => {
    if (!notClickable) {
      setChecked((prevState) => !prevState);
      onChange();
    }
  };

  return (
    <AntSwitch
      className={clsx(styles.root, className)}
      size={size}
      onChange={handleChange}
      checked={shouldUseState ? checked : propChecked}
      style={style}
    />
  );
};
